import { ReactNode, useCallback } from "react"

import { useNavigate } from "react-router-dom"

import { BottomSheetHeights, useApplicationDispatchContext } from "@l2r-front/l2r-utils"

import { useIsMobileDevice } from "../../hooks/useIsMobileDevice"

import * as Styled from "./Kpi.styled"

export type KpiProps = {
    color?: string,
    icon?: ReactNode,
    path?: string,
    title: string,
    value: string | number,
}

export const Kpi = (props: KpiProps) => {

    const {
        icon,
        path,
        title,
        value,
    } = props

    const navigate = useNavigate()
    const isMobile = useIsMobileDevice()
    const { setCurrentBottomSheetHeight } = useApplicationDispatchContext()

    const handleClick = useCallback(() => {
        if (path) {
            navigate(path)
            if (isMobile) {
                setCurrentBottomSheetHeight(BottomSheetHeights.SMALL)
            }
        }
    }, [navigate, path, setCurrentBottomSheetHeight, isMobile])

    return (
        <Styled.KpiCard onClick={handleClick} to="">
            {!isMobile && <Styled.Dummy />}
            <Styled.IconWrapper isMobile={isMobile}>{icon}</Styled.IconWrapper>
            <Styled.Data variant="Desktop & Mobile/Heading/H1" isMobile={isMobile}>{value}</Styled.Data>
            <Styled.Title isMobile={isMobile} variant="Desktop & Mobile/Body/Small">{title}</Styled.Title>
        </Styled.KpiCard>
    )
}
